import { DotsThreeVertical } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";
import { typedObjectEntries } from "common/helpers/utils";

import { WEBHOOKS_ACTIONS } from "../../../constants";
import WebhookActions from "../WebhookActions";

import type { Webhook } from "../../../types";

interface TableProps {
  webhooks: Webhook[];
}

export default function WebhooksDesktopTable({ webhooks }: TableProps) {
  const [actionState, setActionState] = useState<{
    isOpen: boolean;
    action: "delete" | "edit" | "test";
    selectedWebhook: Webhook;
  }>({ isOpen: false, action: "edit", selectedWebhook: undefined });

  const { isOpen, action, selectedWebhook } = actionState;

  return (
    <>
      <Table>
        <thead>
          <tr>
            <TableHead>Webhook name</TableHead>
            <TableHead>URL</TableHead>
            <TableHead>Event</TableHead>
            <TableHead />
          </tr>
        </thead>

        <tbody>
          {webhooks.map((webhook) => {
            const { name, id, url, events } = webhook;

            return (
              <TableRow key={id}>
                <TableCell className="text-md-bold">{name}</TableCell>

                <TableCell>{url}</TableCell>

                <TableCell>
                  {events.length === 1
                    ? events[0]
                    : `${events[0]} (+ ${events.length - 1} more)`}
                </TableCell>

                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        intent="iconOnly"
                        variant="secondary-black"
                        size="sm"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <DotsThreeVertical />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" size="sm">
                      <DropdownMenuList>
                        {typedObjectEntries(WEBHOOKS_ACTIONS).map(
                          ([key, { icon: Icon, label, ...rest }]) => (
                            <DropdownMenuItem
                              key={key}
                              onClick={() =>
                                setActionState({
                                  isOpen: true,
                                  selectedWebhook: webhook,
                                  action: key,
                                })
                              }
                              variant={
                                "isDanger" in rest ? "danger" : "default"
                              }
                            >
                              <Icon />
                              {label}
                            </DropdownMenuItem>
                          ),
                        )}
                      </DropdownMenuList>
                    </DropdownMenuContent>
                  </DropdownMenu>{" "}
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
      {selectedWebhook && (
        <Dialog
          open={isOpen}
          onOpenChange={(isOpen) => setActionState({ ...actionState, isOpen })}
        >
          <DialogContent size={action === "delete" ? "md" : "lg"}>
            <WebhookActions
              action={action}
              webhook={selectedWebhook}
              onClose={() => setActionState({ ...actionState, isOpen: false })}
              onBack={() => setActionState({ ...actionState, isOpen: false })}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
